import { makeAutoObservable, flow, toJS } from 'mobx'
import AsyncStorage from '@react-native-community/async-storage'
import api from '../api'
import _ from 'lodash'

class MemberStore {
    members = []
    memberCount = 0
    member = undefined

    constructor() {
        makeAutoObservable(this)
    }

    listMembers = flow(function* (serach, skip) {
        try {
            const token = yield AsyncStorage.getItem('@token')
            console.log(token)
            const response = yield api.listMembers(serach, skip, token)
            const { members, count } = response.data
            this.members = members
            this.memberCount = count
            return Promise.resolve()
        }
        catch (error) {
            return Promise.reject(error.response.data.errorCodes)
        }
    })

    listMoreMembers = flow(function* (serach, skip) {
        try {
            const token = yield AsyncStorage.getItem('@token')
            const response = yield api.listMembers(serach, skip, token)
            const { members, count } = response.data
            this.members = _.union(this.members, members)
            this.memberCount = count
            return Promise.resolve()
        }
        catch (error) {
            console.log(error)
            return Promise.reject(error.response.data.errorCodes)
        }
    })

    getMember = flow(function* (userId) {
        try {
            const token = yield AsyncStorage.getItem('@token')
            const response = yield api.getMember(token, userId)
            this.member = response.data
            return Promise.resolve()
        }
        catch (error) {
            return Promise.reject(error.response.data.errorCodes)
        }
    })

    updateMember(userId, member) {
        let members = toJS(this.members)
        const index = members.findIndex((f) => { return f._id == userId })
        if (index !== -1) {
            this.members[index] = member
        }
    }
}

export default new MemberStore()